'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./title.scss');

var _withTypography = require('../with-typography');

var _withTypography2 = _interopRequireDefault(_withTypography);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _textToHtml = require('../../utils/text-to-html');

var _textToHtml2 = _interopRequireDefault(_textToHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Title(_ref) {
  var children = _ref.children,
      className = _ref.className,
      density = _ref.density,
      level = _ref.level,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'density', 'level']);

  var classes = (0, _classnames2.default)('title', 'title--density-' + density, 'title--level-' + level, className);

  return _react2.default.createElement('h' + level, _extends({}, { className: classes }, props), typeof children === 'string' ? (0, _textToHtml2.default)(children) : children);
}

Title.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  density: _propTypes2.default.oneOf(['airy', 'comfortable', 'cozy', 'compact', 'none']),
  level: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6'])
};

Title.defaultProps = {
  density: 'comfortable',
  level: '1'
};

exports.default = (0, _withTypography2.default)(Title, { color: 'darkest', weight: 'bold' });